import React from 'react';

// Routes Context
export const RoutesContext = React.createContext();
